import AdherentSearch from "./AdherentSearch.svelte";


const adherentsearch = new AdherentSearch({
    target: document.querySelector('#svelte-adherentsearch'),
    props: {}
});

export default adherentsearch; 